export default {
  GET_KIOSK_PASSWORD: (state, payload) => {
    state.kioskPassword = payload;
  },
  GET_KIOSK_EXPIRY: (state, payload) => {
    state.kioskExpiry = payload;
  },
  SET_PURCHASE: (state, payload) => {
    state.purchase = payload;
  },
  SET_FAILPURCHASE: (state, payload) => {
    state.failPurchase = payload;
  },
  GET_PURCHASE_ID:(state,payload)=>{    
    state.purchaseById = payload;
  },
  RESET_PURCHASE_ID: (state) => {
    state.purchaseById = {
      PONumber:"",
      updatedAt:"",
      deliveryDate:"",
      sapSo:"",
      orderStatus:"",
      customerPO:"",
      items:[],
      customerDetail:{
        type:"",
        companyName:"",
        firstName:"",
        lastName:"",
        phone:""
      },
      dealer:{
        dealerName:""
      },
      gstCalculation:{
        total:0,
        gst:0,
        grandTotal:0
      }
    }
  },
  DELETE_PURCHASE: (state, payload) => {
    let i = state.purchase.find(u => u.id === payload)
    state.purchase.splice(i, 1)
  },
  SET_DASHBOARD_FIELD: (state, payload) => {


    var allField=[]

    allField.push({ key: 'itemModel', label: 'Item', filterable: true, sortable: true })

    payload.forEach(counter => {
      allField.push({ key: counter, label: counter, filterable: true, sortable: true })
    })

    allField.push({ key: 'reserved', label: 'Reserved for Picking', filterable: true, sortable: true })
    allField.push({ key: 'picked', label: 'Picked', filterable: true, sortable: true })
    allField.push({ key: 'location', label: 'Location', filterable: true, sortable: true })

    state.ekioskDashboardField = allField;
  },
  SET_DASHBOARD_DATA: (state, payload) => {
    state.ekioskDashboardData = payload;
  }
}
